import { render, staticRenderFns } from "./Tempos.vue?vue&type=template&id=1277d8a2"
import script from "./Tempos.vue?vue&type=script&lang=js"
export * from "./Tempos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports